import { useState, useEffect } from 'react';

import {
  createUserNPS,
  updateUserNPS,
  streamUserNPS,
} from 'Util/FirebaseService/FirestoreService/PreferenceNPS';
import { useAuthenticationFirebase } from 'Context/FirebaseAuthenticationContext';

// state for show feedback modal
export const NPS_STATE = {
  PROGRESS_60: 'PROGRESS_60', // will show feedback when progress >= 60
  PROGRESS_80: 'PROGRESS_80', // will show feedback when progress >= 80
  NONE: 'NONE', // will not show feedback
  // TIME: (collect as millisecond time) will plus with feedback duration config to get time to show feedback
};

const defaultNPSState = NPS_STATE.PROGRESS_60;

function checkNPSStateIsCorrect(npsState) {
  if (Object.values(NPS_STATE).includes(npsState)) {
    return true;
  }
  if (!isNaN(npsState) && new Date(npsState) > 0) {
    return true;
  }
  return false;
}

const useNPSState = ({ courseCode }) => {
  const [currentNPSState, setNPSState] = useState(null);
  const { user: firebaseUser, isFirebaseInitialize } = useAuthenticationFirebase();

  useEffect(() => {
    if (isFirebaseInitialize && firebaseUser && courseCode !== '' && courseCode !== undefined) {
      const unsubscribe = streamUserNPS(firebaseUser.id, {
        next: (docSnapshot) => {
          const docData = docSnapshot.data();
          if (!docSnapshot.exists) {
            createUserNPS(firebaseUser.id, courseCode, defaultNPSState);
          } else if (!docData[courseCode] || !checkNPSStateIsCorrect(docData[courseCode])) {
            updateUserNPS(firebaseUser.id, courseCode, defaultNPSState);
          } else {
            setNPSState(docData[courseCode]);
          }
        },
        error: () => {},
      });
      return unsubscribe;
    }
  }, [courseCode, firebaseUser]);

  const updateNPSState = (nextFeedback) => {
    updateUserNPS(firebaseUser.id, courseCode, nextFeedback);
  };

  return [currentNPSState, updateNPSState];
};

export default useNPSState;
